registerComponent("product-blocks/product-platforms-hedge-prev", function (component) {

});
